import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../api/api";
import { useApi } from "../core/hooks/useApi";
import { useConditional } from "../core/hooks/useConditional";
import { Table } from "../core/ui/Table";
import { FormModal } from "../data-entry/FormModal";
import { AusPhoneNumberCol, CombineColumns, CustomCol, GenericCol, IDCol, LastUpdatedCol } from "../layout/TableCells";
import { job } from "../types";
import { newID } from "../core/utils/unique";
import { IndividualNameCol } from "../pages/entity/Individual";
import { broadcast, useChannel } from "../core/hooks/useChannel";
import { Modal } from "../core/ui/Modal";
import { hasRole, logoff } from "../core/hooks/useSession";
import { LoginModal } from "../pages/auth/LoginModal";
import { formatAusMobile, formatCurrency } from "../formatters/format";
import { Spinner } from "../core/ui/Spinner";
import { HistoricalDate } from "../core/ui/HistoricalDate";
import { Icon } from "../core/ui/icons";
import { EditableTable } from "../core/ui/EditableTable";
import { InlineReport } from "../data-entry/InlineReport";
import { OptionsButton } from "../pages/dashboard/CurrentForms";
import { DataContext, useDataContext } from "../core/hooks/useData";
import { useRefresh } from "../core/hooks/useRefresh";

const CHANNEL = "techsync";

const CSS_VERSION = "6";

const Messages = {
	START_CAPTURE: "start-capture",

	VIEW_VIDEO: "view-video",

	SHOW_JOB_CARD: "show-job-card",

	COMPLETE_JOB: "complete-job",

	JOB_DELETED: "job-deleted",
}




function ActionsCol() {
	return {
		className: "align-right",

		title: (c: any) => {
			return "Actions";
		},

		value: (r: any, c: any) => {

			let videos = [];
			if (r.videos) {
				let i = 1;
				for(let v of r.videos) {
					let duration = "";

					if (v.duration) {
						duration = formatCurrency(v.duration, { min: 0, max: 1 }, "") + "s";
					}

					videos.push(
						<li key={i}
							onClick={(e) => {
								e.stopPropagation();

								broadcast(CHANNEL, {
									type: Messages.VIEW_VIDEO,
									video: v,
									job: r,
								});
							}}
						><Icon type="play" size="small" />{`Video ${i}`}&nbsp;<span className="tag">{duration}</span></li>
					);
					i++;
				}
			// } else {
			// 	videos.push(<i key={0}>No videos uploaded</i>);
			}


			return (
				//<div className="actions flex horiz gap-3 align-start">
				<div className="buttons flex horiz gap-5 relative justify-end">
					<OptionsButton>
						<li
							onClick={(e) => {
								broadcast(CHANNEL, {
									type: Messages.START_CAPTURE,
									job: r,
								});
								e.stopPropagation();
								e.preventDefault();
							}}
						><Icon type="record" size="small" />Record</li>
						{videos}

						<div className="sep" />

						{/* <li
							onClick={(e) => {
								e.stopPropagation();
								broadcast(CHANNEL, {
									type: Messages.SHOW_JOB_CARD,
									job: r,
								});
							}}
						><Icon type="jobcard" size="small" />Job Card</li> */}
						<li
							onClick={(e) => {
								// eslint-disable-next-line no-restricted-globals
								if (confirm("Are you sure you want to send this job to the customer?")) {
									api.job_send_sms({
										job: r.id
									}).then(() => {
										alert("Sent");
		
									}).catch((e) => {
										alert("Error, unable to send");
		
									});	
								}

								e.stopPropagation();
							}}
						>
							<Icon type="send" size="small" />Send&nbsp;
							{
								r.lastSent && 
								<HistoricalDate dt={r.lastSent} />
							}
						</li>

						{r.mobile &&
							<div className="sep" />
						}

						{r.mobile &&
						<li onClick={(e) => {
							e.stopPropagation();
						}}>
							<a href={"tel:" + r.mobile} style={{textDecoration: "none"}}><Icon type="call" size="small" />Call {formatAusMobile(r.mobile)}</a>
						</li>
						}

						<div className="sep" />

						<li
							className="success"
							onClick={(e) => {
								e.stopPropagation();

								broadcast(CHANNEL, {
									type: Messages.COMPLETE_JOB,
									job: r,
								});							
							}}
						><Icon type="tick" size="small" />Complete</li>

						<div className="sep" />

						<li
							onClick={(e) => {
								e.stopPropagation();

								// eslint-disable-next-line no-restricted-globals
								if (confirm("Are you sure you want to permanently DELETE this job?")) {
									api.job_delete({
										id: r.id
									}).then(() => {
										broadcast(CHANNEL, {
											type: Messages.JOB_DELETED,
											job: r,
										});
		
									}).catch((e) => {
										alert("Error, unable to send");
		
									});	
								}
							}}
						><Icon type="delete" size="small" />Delete</li>


					</OptionsButton>
				</div>
			)
		}	
	};
}

export function VideoPlay(props: {
	title: string,
	blob: string,
	onClose: () => void,
	onDelete: () => void,
}) {

	const [sasToken, setSasToken] = useState({
		blobName: "",
		token: "",
	});

	useEffect(() => {
		api.job_get_sas_token({
			blob: props.blob,
		}).then((token: any) => {
			setSasToken(token);

		}).catch((e) => {

		});
	}, []);


	let video;

	if (sasToken && sasToken.blobName) {
		const url = `https://guardia.blob.core.windows.net/techsync/${sasToken.blobName}?${sasToken.token}`;
		video = 
			<video id="vid" width="320" height="240" controls autoPlay={true}>
				<source src={url} type="video/mp4" />
			</video>
		;
	}

	return (
		<Modal
			title={props.title}
			showSave={false}
			cancelTitle="Close"
			onCancel={props.onClose}
			showDelete={true}
			onDelete={props.onDelete}
		>
			<div className="flex vert space-evenly">
				{
					!video &&
					<div>Loading, please wait ...</div>
				}
				{video}
			</div>
		</Modal>
	)
}

function getVideoDuration(blob: Blob) {
    return new Promise<number>((resolve, reject) => {
        // Create a video element
        const video = document.createElement('video');
        
        // Use Blob URL to set the video source
        video.src = URL.createObjectURL(blob);

        // Event listener for when the metadata is loaded
        video.addEventListener('loadedmetadata', function() {
            // Get duration in seconds
            const duration = video.duration;
            // Clean up the blob URL to avoid memory leaks
            URL.revokeObjectURL(video.src);
            // Resolve the promise with the duration
            resolve(duration);
        });

        // Error handling
        video.addEventListener('error', function() {
            reject(new Error('Error loading video'));
        });
    });
}

export function Capture(props: {
	job: any,
	onStopped: () => void,
}) {
	const [isRecording, setIsRecording] = useState(false);
	const [isFlashOn, setIsFlashOn] = useState(false);
	const ref = useRef<HTMLVideoElement>(null);
	const recorder = useRef<MediaRecorder | null>(null);
	const chunks = useRef<any[]>([]);

	const [isUploading, setIsUploading] = useState(false);

	const sasToken = useRef({
		blobName: "",
		token: "",
	});

	useEffect(() => {
		// get a token for writing the blob
		api.job_get_sas_token({}).then((result: any) => {
			sasToken.current = result;
		}).catch((e) => {

		});

	}, []);

	useEffect(() => {
		if (!ref.current) return;

		function stopCamera(stream: MediaStream | undefined) {
			if (stream) {
				let tracks = stream.getTracks() as MediaStreamTrack[];
				tracks.forEach(track => track.stop());
			}
		}

		let g_stream: MediaStream | undefined;
		let g_video: HTMLVideoElement | null;

		// Request access to the user's camera
		navigator.mediaDevices.getUserMedia({ 
			video: { 
				facingMode: 'environment', 
				torch: true, //isFlashOn 
			} as MediaTrackConstraints
		}).then(function (stream) {
			g_stream = stream;

			// Once we have access, we can use the stream
			g_video = ref.current;
			if (g_video) {
				g_video.srcObject = stream;
				g_video.play();

				recorder.current = new MediaRecorder(stream);
				chunks.current = [];

				recorder.current.ondataavailable = function (e) {
					chunks.current.push(e.data);
				};

				recorder.current.onstop = function () {
					const blob = new Blob(chunks.current, { 'type': 'video/mp4' });

					// upload video
					if (sasToken.current.blobName && sasToken.current.token) {
						setIsUploading(true);

						// get duration of video
						getVideoDuration(blob).then((duration: number) => {

							// upload to azure
							uploadBlobToAzure(blob).then(() => {

								// now update the job to link this video
								api.job_link_video({
									job: props.job.id,
									video: sasToken.current.blobName,
									size: blob.size,
									duration,
								}).then(() => {
									props.onStopped();
	
								}).catch((e) => {
	
								});
	
	
							}).catch((e) => {
	
							});
	

						}).catch((e) => {
							
						})


					}

					// Here you can handle the video blob (e.g., download, upload)
				};
			}
		}).catch(function (err) {
			console.error('An error occurred: ' + err);
		});

		// Cleanup function to stop the camera when component unmounts
		return () => {
			stopCamera(g_stream);
			if (g_video) g_video.srcObject = null;
		};

	}, [isFlashOn]);

	const toggleRecording = () => {
		if (isRecording) {
			recorder.current?.stop();
		} else {
			recorder.current?.start();
		}
		setIsRecording(!isRecording);
	};

	async function uploadBlobToAzure(blob: Blob): Promise<void> {
		const blobUrl = `https://guardia.blob.core.windows.net/techsync/${sasToken.current.blobName}?${sasToken.current.token}`;
	
		try {
			const response = await fetch(blobUrl, {
				method: 'PUT',
				headers: {
					'x-ms-blob-type': 'BlockBlob',
					'Content-Type': 'video/mp4'
				},
				body: blob
			});
	
			if (!response.ok) {
				throw new Error(`HTTP error, status = ${response.status}`);
			}

			console.log('File uploaded successfully');
		} catch (error) {
			console.error('An error occurred during upload:', error);
		}
	}

	// const toggleFlash = () => {
	// 	setIsFlashOn(!isFlashOn);
	// };

	return (
		<div className="flex vert gap-2">
			{isUploading &&
				<h3>Uploading, please wait ...</h3>
			}
			
			{!isUploading &&
				<>
					<video id="videoElement" width="320" height="240" ref={ref} autoPlay={true} controls={true} playsInline={true}></video>
					<div className="flex gap-2">
						<button onClick={toggleRecording}>
							{isRecording ? 'Stop Recording' : 'Start Recording'}
						</button>

						{/* <button onClick={toggleFlash}>
							{isFlashOn ? 'Turn Off Flash' : 'Turn On Flash'}
						</button> */}
					</div>
				</>
			}
		</div>
	);
}

export function ActiveJobs(props: {

}) {

	const [token, setToken] = useState("");

	const jobs = useApi<job[]>({
		request: () => {
			return api.job_get_all({});
		},
	}, [token]);

	useChannel(CHANNEL, useCallback((msg) => {
		if (msg.type === Messages.START_CAPTURE) {
			captureModal.show(msg.job);
		
		} else if (msg.type === Messages.VIEW_VIDEO) {
			viewVideoModal.show(msg);

		} else if (msg.type === Messages.SHOW_JOB_CARD) {
			jobCardModal.show(msg.job);

		} else if (msg.type === Messages.COMPLETE_JOB) {
			completeJobModal.show(msg.job);

		} else if (msg.type === Messages.JOB_DELETED) {
			setToken(newID());

		}

	}, []));

	const completeJobModal = useConditional((job: any) => {
		return (
			<Modal
				title={`Complete Job #${job.num}`}
				size="width-50vw"
				saveTitle="Complete"
				onCancel={completeJobModal.close}
				onSave={() => {
					api.job_complete({
						job: job.id,
					}).then(() => {
						setToken(newID());
						completeJobModal.close();
					}).catch((e) => {

					});
				}}
			>
				Has this job been fully completed? Continuing will close this job and it will no longer be accessible.
			</Modal>
		)
	});

	const jobCardModal = useConditional((job: any) => {
		return (
			<TechsyncJobCard
				jobID={job.id}
				onClose={jobCardModal.close}
			/>
		)
	});

	const viewVideoModal = useConditional((props: any) => {
		return (
			<VideoPlay 
				blob={props.video.blob}
				onClose={viewVideoModal.close}
				onDelete={() => {
					api.job_delete_video({
						job: props.job.id,
						blob: props.video.blob,
					}).then(() => {
						setToken(newID());
						viewVideoModal.close();
					}).catch((e) => {

					});
				}}
				title={"View Video"}
			/>
		)
	});

	const editModal = useConditional((job: any) => {

		if (!job.invoice) job.invoice = [];
		const invoice = job.invoice;

		const cols = [
			{
				id: "desc",
				title: "Item Description", 
				datatype: "string"
			},
			{
				id: "qty",
				title: "Qty", 
				datatype: "number"
			},
			{
				id: "cost",
				title: "Cost (ex GST)", 
				datatype: "number"
			},
		];

		return (
			<FormModal
				title={(job.id ? `Edit job #${job.num}` : "Create Job")}
				form="techsync-job-create"
				onCancel={editModal.close}

				obj={job}

				onSave={(value: any) => {
					const job = {
						id: value.id,
						num: value.num,
						name: value.name,
						mobile: value.mobile,
						notes: value.notes,
						invoice,
						deleted: false,
						complete: false,
					};

					api.job_post(job).then(() => {
						setToken(newID());
						editModal.close();
					}).catch(() => {

					});					

				}}
			>
				<div style={{padding: "10px 0"}}>
					<h5 className="flex gap-5">
						Parts and Labour
						{
							job.quote_approved &&
							<div className="tag success">Quote Approved</div>
						}
					</h5>
					{
						job.quote_approved &&
						<Table
							cols={cols}
							items={invoice}
							render={{
								colTitle: (c) => {
									return c.title;
								},
								colValue: (r: any, c) => {
									return r[c.id];
								},
							}}
						/>
					}

					{ 
						!job.quote_approved &&
						<EditableTable
							options={{
								columnsEditable: false,
								addRowButton: true,
								deleteRowButton: true,
							}}
							data={{
								columns: cols as any,
								rows: invoice,
							}}
						/>
					}
				</div>
			</FormModal>
		)
	});

	const captureModal = useConditional((job: any) => {
		return (
			<Modal
				title="Capture Video"
				size="width-100pc"
				onCancel={() => {
					// refresh jobs
					setToken(newID());
					captureModal.close();
				}}
				onSave={() => {

				}}
			>
				<Capture
					job={job}
					onStopped={() => {
						// reload list
						setToken(newID());
						captureModal.close();
					}}
				/>
			</Modal>
		)
	});

	// setup interval each time something changes
	useEffect(() => {
		const h = setInterval(() => {
			if (
				completeJobModal.isShowing() || 
				jobCardModal.isShowing() || 
				viewVideoModal.isShowing() ||
				editModal.isShowing() ||
				captureModal.isShowing()
			) {
				return;
			}

			setToken(newID());
		}, 20000);

		return () => {
			if (h) clearInterval(h);
		}
	});


	return (
		<div style={{paddingBottom: "50vh"}}>
			<div
				className="flex horiz align-center gap-10"
				style={{
					backgroundColor: "#333",
					padding: "5px 20px",
					color: "#fff",
					fontWeight: "bold",
					borderBottom: "solid #ddd 1px"
				}}
			>
				<span>Techsync</span>
				<img src="/img/agmoto-inverse.png" width="100" style={{marginTop:"4px"}} />
				<div className="flex horiz gap-5">
					<button
						onClick={() => {
							editModal.show({});
						}}
					>Create</button>

					<button
						onClick={() => {
							logoff();
							document.location.href = "/techsync/";
						}}
					>Logout</button>
				</div>
			</div>
			<div className="padding-10">
				<Table
					className="techsync active-jobs"
					cols={[
						//GenericCol("Job Number", "num", "align-center"),
						CustomCol({
							className: "align-center",
							title: () => "Job Number",
							value: (r, c) => {
								return (
									<div className="flex vert">
										{r.num}
										{
											r.invoice && r.invoice.length > 0 &&
											<div className="tag secondary">Quoted</div>
										}
										{
											r.quote_approved && 
											<div className="tag success gap-2" style={{display:"flex", alignItems:"center"}}><Icon type="tick" size="small" />Approved</div>
										}
									</div>
								)
							}
						}),
						//IDCol(),
						CombineColumns({
							title: "Customer",
							cols: [
								IndividualNameCol({
									title: "Customer Name"
								}),
								AusPhoneNumberCol("Mobile", "mobile"),		
								LastUpdatedCol(),
							]
						}),
						GenericCol("Notes", "notes", "desktop-only width-25pc"),
						CustomCol({
							className: "desktop-only width-25pc align-center",
							title: () => "Additional Work",
							value: (r, c) => {
								if (r.invoice && r.invoice.length > 0) {
									let total = 0;
									for(let i of r.invoice) {
										total += i.qty * i.cost;
									}
									return formatCurrency(total * 1.1);
								} else {
									return undefined;
								}
							},
						}),
						ActionsCol(),

					]}
					items={jobs}
					interactive={true}
					onClick={(e, r) => {
						editModal.show(r);
					}}
				/>

				{editModal.render()}
				{captureModal.render()}
				{viewVideoModal.render()}
				{jobCardModal.render()}
				{completeJobModal.render()}
			</div>
		</div>
	);

}

export function TechsyncJobCard(props: {
	jobID: string,
	onClose: () => void,
}) {

	const [job, setJob] = useState<any>(null);
	const refresh = useRefresh();
	const [err, setErr] = useState("");

	const dataContext = useDataContext({
		initialValue: {},
	});
	dataContext.validate();

	useEffect(() => {
		api.job_get({
			id: props.jobID,
		}).then((job: any) => {
			debugger;
			if (job && job.id) {
				setJob(job);
			} else {
				setErr("Ticket is no longer available");
			}
		}).catch((e) => {

		});
	}, [refresh.token]);

	const [sasToken, setSasToken] = useState({
		blobName: "",
		token: "",
	});

	useEffect(() => {
		if (!job) return;
		if (!job.videos || job.videos.length <= 0) return;

		api.job_get_sas_token({
			blob: job.videos[0].blob,
		}).then((token: any) => {
			setSasToken(token);

		}).catch((e) => {

		});
	}, [job]);

	const approveModal = useConditional(() => {
		return (
			<Modal
				title="Approve Quote"
				onCancel={approveModal.close}
				onSave={() => {
					api.job_approve_quote({
						job: job.id,
					}, dataContext).then(() => {
						refresh.refresh();
						approveModal.close();
					}).catch((e) => {

					});
				}}
				saveTitle="Approve Quote"
			>
				By approving this quote you are agreeing for the additional work to be performed at the quoted price.
			</Modal>
		)
	});


	let videos;

	if (sasToken && sasToken.token) {
		videos = [];

		for(let v of job.videos) {
			const url = `https://guardia.blob.core.windows.net/techsync/${v.blob}?${sasToken.token}`;

			videos.push(
				<video id="vid" width="320" height="240" controls preload="auto" autoPlay={false} key={v.blob}>
					<source src={url} type="video/mp4" />
				</video>
			);
		}

		videos = 
			<div className="flex vert align-center gap-10 margin-top-5">
				{videos}
			</div>

	} else {
		videos = <Spinner size="small" />
	}

	let result;

	if (job) {

		let invoice;
		if (job.invoice && job.invoice.length > 0) {
			invoice = (
				<div className="width-100pc" style={{
					paddingTop: "10px",
					marginTop: "10px",
				}}>
					<h5>Additional Work</h5>
					<div className="bg-brand-secondary-soft" style={{paddingBottom: "10px"}}>
						<InlineReport
							data={job}
							reportID="techsync-invoice"
						/>
						<div className="flex vert align-center gap-5 padding-5">
							{job.quote_approved &&
							<>
								<div className="tag secondary gap-10" style={{display:"flex", alignItems: "center", textAlign:"left", padding:"10px"}}>
									<Icon type="tick" style={{flexGrow:"0"}} />
									You have given approval for this work to commence at the quoted price
									<HistoricalDate dt={job.quote_approved} />
								</div>
							</>
							} 

							{!job.quote_approved &&
							<>
								<div>Please confirm you approve this quote and that work can be commenced</div>
								<button
									className="success"
									onClick={() => {
										approveModal.show({});
									}}
								><Icon type="tick" size="small" />Approve</button>						
							</>
							}
						</div>
					</div>
				</div>
			);
		}

		result = (
			<div className="flex align-center vert width-100pc space-auto">
				<h3>{"Service Ticket #" + job.num}</h3>
				<div>Updated: <HistoricalDate dt={job.updated} /></div>
				
				<div style={{
					padding: "10px 20px",
					textAlign: "center",
					margin: "10px",
					backgroundColor: "#dcddde",
					border: "solid #ddd 1px",
					borderRadius: "7px",
				}}>
					<h4>{formatAusMobile(job.mobile)}</h4>
					{
						job.name &&
						<div>
							{job.name.given1 ? job.name.given1 : ""} {job.name.family ? job.name.family : ""}
						</div>
					}
				</div>

				{
					job.notes &&
					<div className="width-100pc" style={{
						paddingTop: "10px",
						marginTop: "10px",
					}}>
						<h5>Technician Notes</h5>
						{job.notes}
					</div>
				}

				{
					job.videos && job.videos.length > 0 &&
					<div className="width-100pc" style={{
						paddingTop: "10px",
						marginTop: "10px",
					}}>
						<h5>Video Reports</h5>
						{videos}
					</div>
				}

				{invoice}

					<div className="width-100pc" style={{
						paddingTop: "10px",
						marginTop: "10px",
					}}>
					<h5>Store Details</h5>
					<div style={{textAlign:"center"}}>
						<div>6/9 Southeast Boulevard, Pakenham, VIC 3810</div>
						<div><a href="mailto:rod.hine@agmoto.com.au">rod.hine@agmoto.com.au</a></div>
						<div><a href="tel:(03) 5922 4520" style={{fontSize: "28px"}}>(03) 5922 4520</a></div>
					</div>
				</div>


			</div>
		);
	} else if (err) {
		result = <div>{err}</div>;
	} else {
		result = (
			<Spinner size="large" />
		)
	}

	let closeButton = hasRole("techsync") ? <button onClick={props.onClose} style={{position:"absolute", right:"10px", top: "10px", zIndex: "999"}}>Close</button> : undefined;

	return (
		<DataContext.Provider value={dataContext}>
			<link href={"/ts.css?version=" + CSS_VERSION} rel="stylesheet" />
			<div
				className="width-100vw height-100vh absolute padding-10 flex vert"
				style={{
					top: "0", left: "0", overflow: "auto", backgroundColor: "#fff",
					paddingTop: "50px",
					paddingBottom: "100px"
				}}
			>
				{closeButton}
				{result}
			</div>
			{approveModal.render()}
		</DataContext.Provider>
	);
}


export function TechsyncHome(props: {

}) {

	const loginModal = useConditional(() => {
		return (
			<LoginModal
				onClose={loginModal.close}
				onSuccess={() => {
					document.location.reload();
					return true;
				}}
			/>
		);
	});

	let result;

	if (hasRole("techsync")) {
		result = <ActiveJobs />;
	} else {
		result = (
			<div className="flex align-center width-100vw height-100vh space-evenly">
				<button 
					onClick={() => {
						loginModal.show({});
					}}
				>Login</button>

				{loginModal.render()}
			</div>
		);
	}

	return (
		<div>
			<link href={"/ts.css?version=" + CSS_VERSION} rel="stylesheet" />
			{result}
		</div>
	)

}




